import { gql } from 'graphql-tag';
export const COLLECTION_SHALLOW_FRAGMENT = `
  fragment CollectionShallowFragment on Collection {
    __typename
    id
    displayMode
    isUserDependent
    redirectParentId
    name
    slug
    description
    cover {
      __typename
      id
      src
    }
    cachedGrants
    isPlaylist
  }
`;
export const COLLECTION_DEEP_FRAGMENT = `
  fragment CollectionDeepFragment on Collection {
    __typename
    id
    displayMode
    isUserDependent
    displayConfig {
      displayHero
    }
    redirectParentId
    name
    slug
    description
    cover {
      __typename
      id
      src
    }
    cachedGrants
    isPlaylist
  }
`;
export const COLLECTION_GET = gql `
  ${COLLECTION_DEEP_FRAGMENT}
  query Collection (
    $id: ID!
  ) {
    Collection(
      id: $id,
    ) {
      ...CollectionDeepFragment
    }
  }
`;
//# sourceMappingURL=collection.js.map